import React, { createContext, useContext, useState, useEffect } from 'react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import { translations, getLanguageByIP } from '../utils/i18n';

const LanguageContext = createContext();

const antdLocales = {
  'zh-CN': zhCN,
  'en-US': enUS,
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en-US');

  useEffect(() => {
    const initLanguage = async () => {
      const savedLang = localStorage.getItem('language');
      if (savedLang && antdLocales[savedLang]) {
        setLanguage(savedLang);
      } else {
        const detectedLang = await getLanguageByIP();
        setLanguage(detectedLang);
        localStorage.setItem('language', detectedLang);
      }
    };
    initLanguage();
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  // t(key) returns string; t(key, ...args) calls the function translation
  const t = (key, ...args) => {
    const val = translations[language]?.[key];
    if (typeof val === 'function') return val(...args);
    return val || key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      <ConfigProvider locale={antdLocales[language]}>
        {children}
      </ConfigProvider>
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
